import { format } from "date-fns";
import { useState, useEffect } from "react";
import { Spinner } from "../../../../shared";
import "../../../../shared/styles/UnifiedTable.css";

const TablaProcesos = ({ data, onClick, onChange, sort, setSort }) => {
  const [seleccion, setSeleccion] = useState(null);

  useEffect(() => {
    const persona_id = localStorage.getItem("reportes-atrasos-persona");
    if (persona_id) {
      setSeleccion(persona_id);
    }
  }, []);
  return (
    <div className="unified-table-container">
      <table className="unified-table">
        <thead>
          <tr>
            <th className="text-center"><div>Acciones</div></th>
            <th className="text-center"><div>Proceso</div></th>
            <th className="text-center">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort:
                      sort == "-procesos.created_at" ? "procesos.created_at" : "-procesos.created_at",
                  })
                }
              >
                <span>Fecha</span>
                <i className={sort == "procesos.created_at" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-start">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort: sort == "-apellido" ? "apellido" : "-apellido",
                  })
                }
              >
                <span>Cliente</span>
                <i className={sort == "apellido" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-start"><div>Teléfono</div></th>
            <th className="text-center"><div>Al día</div></th>
            <th className="text-center"><div>Atrasados</div></th>
            <th className="text-center">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort:
                      sort == "-ultimo_pago.created_at"
                        ? "ultimo_pago.created_at"
                        : "-ultimo_pago.created_at",
                  })
                }
              >
                <span>Último pago</span>
                <i className={sort == "ultimo_pago.created_at" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-center">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort:
                      sort == "-procesos.ultimaTarea.fecha_vencimiento"
                        ? "procesos.ultimaTarea.fecha_vencimiento"
                        : "-procesos.ultimaTarea.fecha_vencimiento",
                  })
                }
              >
                <span>Última tarea</span>
                <i className={sort == "procesos.ultimaTarea.fecha_vencimiento" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-center"><div>Estado</div></th>
          </tr>
        </thead>

      {!data ? (
        <tbody>
          <tr>
            <td colSpan={10} style={{ textAlign: 'center', padding: '40px' }}>
              <Spinner />
            </td>
          </tr>
        </tbody>
      ) : (
        <tbody>
          {data.map((d, index) => (
            <tr
              key={index}
              className={seleccion == d.id ? "selected" : ""}
              style={{
                boxShadow: seleccion == d.id ? "0 0 0 3px #0EA5E9" : "",
              }}
              onClick={() => {
                //setSeleccion(d.persona.id);
                //localStorage.setItem("reportes-atrasos-persona", d.persona.id);
              }}
            >
              <td className="text-center">
                <div className="d-flex gap-2 justify-content-center">
                  <button
                    className="btn btn-sm"
                    style={{
                      background: 'linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)',
                      color: '#FFFFFF',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '6px 12px',
                      fontSize: '0.85rem',
                      fontWeight: '600'
                    }}
                    title="Editar"
                    onClick={() => {
                      window.location.href =
                        "/gestion-mora/reportes-atrasos/editar/" + d.id;
                    }}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    className="btn btn-sm"
                    style={{
                      background: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)',
                      color: '#FFFFFF',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '6px 12px',
                      fontSize: '0.85rem',
                      fontWeight: '600'
                    }}
                    title="Eliminar"
                    name="eliminar-proceso"
                    onClick={(event) => onClick(event, d)}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </td>
              <td className="text-center">
                <span className="unified-badge unified-badge-info">
                  #{d.procesos[0].id}
                </span>
              </td>
              <td className="text-center">
                {format(
                  new Date(d.procesos[0].created_at),
                  "dd/MM/yyyy"
                )}
              </td>
              <td className="text-start">
                <a
                  className="unified-table-link"
                  href={`/clientes/ver/${d.id}`}
                  target="_blank"
                >
                  {d.apellido + " " + d.nombre}
                </a>
              </td>
              <td className="text-start">
                {d.contactos.map((c, idx) => (
                  <div key={idx}>
                    {c.nro_telefono_prefix + "-" + c.nro_telefono}
                  </div>
                ))}
              </td>
              <td className="text-center">
                {d.deudaAcumulada.map((credito, idx) => {
                  if (credito.deuda == 0) {
                    return (
                      <a
                        key={idx}
                        className="unified-table-link d-block"
                        href={`/creditos/ver/${credito.credito_id}`}
                        target="_blank"
                      >
                        #{credito.credito_id}
                      </a>
                    );
                  }
                })}
              </td>
              <td className="text-center">
                {d.deudaAcumulada.map((credito, idx) => {
                  if (credito.deuda > 0) {
                    return (
                      <a
                        key={idx}
                        className="unified-table-link d-block"
                        href={`/creditos/ver/${credito.credito_id}`}
                        target="_blank"
                      >
                        #{credito.credito_id}
                      </a>
                    );
                  }
                })}
              </td>
              <td className="text-center">
                {d.ultimoPago.map((p, idx) => (
                  <div key={idx}>
                    {format(new Date(p.created_at), "dd/MM/yyyy")}
                  </div>
                ))}
              </td>
              <td className="text-center">
                {d.procesos[0].ultima_tarea.length > 0
                  ? format(
                      new Date(d.procesos[0].ultima_tarea[0].fecha_vencimiento),
                      "dd/MM/yyyy"
                    )
                  : <span className="text-muted">Sin tareas</span>}
              </td>
              <td className="text-center">
                <span className={
                  d.procesos[0].estado === 'activo' ? 'unified-badge unified-badge-success' :
                  d.procesos[0].estado === 'inactivo' ? 'unified-badge unified-badge-secondary' :
                  d.procesos[0].estado === 'juicio' ? 'unified-badge unified-badge-danger' :
                  'unified-badge unified-badge-info'
                }>
                  {d.procesos[0].estado}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      )}
      <tfoot></tfoot>
    </table>
    </div>
  );
};

export default TablaProcesos;
